import React from 'react';
import { Typography } from 'antd';
import List from './List';

export default function Complexes(): React.ReactNode {
  return (
    <div>
      <Typography.Title level={4}>
        Комплексы
      </Typography.Title>
      <List />
    </div>
  );
}
